import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import ErrorActions from './error';
import CartActions from './cart';

export default class JoyrideActions {
    static STATUS = {
        UNFINISHED: 'unfinished',
        FINISHED: 'finished',
        CANCELED: 'canceled',
    };

    static types = actionsFromList([
        'START_JOYRIDE',
        'FINISH_JOYRIDE',
        'CANCEL_JOYRIDE',
        'SAVING_JOYRIDE_STATUS',
        'SAVED_JOYRIDE_STATUS',
    ]);

    // sync --------------------------------------------------------------------

    static savingJoyrideStatus = (status) => ({
        type: JoyrideActions.types.SAVING_JOYRIDE_STATUS,
        payload: { status },
    });

    static savedJoyrideStatus = () => ({
        type: JoyrideActions.types.SAVED_JOYRIDE_STATUS,
    });

    // async -------------------------------------------------------------------

    static startJoyride = () => (dispatch) => {
        dispatch({ type: JoyrideActions.types.START_JOYRIDE });
        dispatch(
            JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.UNFINISHED)
        );
    };

    static cancelJoyride = () => (dispatch) => {
        dispatch({ type: JoyrideActions.types.CANCEL_JOYRIDE });
        dispatch(
            JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.CANCELED)
        );
        dispatch(CartActions.setItems());
    };

    static finishJoyride = () => (dispatch) => {
        dispatch({ type: JoyrideActions.types.FINISH_JOYRIDE });
        dispatch(
            JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.FINISHED)
        );
        dispatch(CartActions.setItems());
    };

    static updateJoyrideStatus = (status) => (dispatch, getState) => {
        const state = getState();

        dispatch(JoyrideActions.savingJoyrideStatus(status));

        state.api
            .updateMyPreferences({ joyrideStatus: status })
            .then((response) =>
                dispatch(JoyrideActions.savedJoyrideStatus(response))
            )
            .catch(ErrorActions.errorHandler(dispatch));
    };
}



// WEBPACK FOOTER //
// ./app/actions/joyride.js